import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/notarias_webs_nuxt/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/notarias_webs_nuxt/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/notarias_webs_nuxt/layouts/error.vue").then(m => m.default || m))
}